export class HeatmapData {
  left: any | undefined;
  right: any | undefined;

  constructor(left: any, right: any) {
    this.left = left;
    this.right = right;
  }
}
